<template>
  <sidepanel id="select-marker" title="Select marker" :processing="processing">
    <div
      v-for="(marker, key) in markers"
      :key="marker.id"
      @click="
        selectMarker({
          id: key,
          title: marker.name,
          type: marker.type,
          unit: marker.unit,
          value: null
        })
      "
      class="marker-option"
      :class="{ disabled: selectedMarkers.find(marker => marker.id === key) }"
    >
      {{ marker.name }}
    </div>
  </sidepanel>
</template>

<script>
export default {
  data() {
    return {
      markers: [],
      processing: false
    };
  },
  props: {
    selectedMarkers: {
      type: Array
    }
  },
  methods: {
    selectMarker(obj) {
      this.$emit("select", obj);
      this.removePanel();
    }
  },
  async mounted() {
    this.processing = true;
    this.markers = await this.$store.dispatch("KitsStore/getMarkers");
    this.processing = false;
  }
};
</script>

<style lang="less" scoped>
@import "../../styles/vars";
.marker-option {
  padding: @h1;
  margin-bottom: 1px;
  background-color: #eee;
  cursor: pointer;
  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
</style>